var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.tableData,
          search: _vm.search,
          pagination: _vm.pagination
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c("td", [_vm._v(_vm._s(props.item.titulo))]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.num_solicitud))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.patente))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.serie))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.razon_social))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.rut))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.ejecutivo))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.tipo))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.fecha_creacion))
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(props.item.descripcion.substring(0, 50)) +
                      "...\n      "
                  )
                ]),
                _c("td", { staticClass: "text-xs-center" }, [
                  _vm._v(_vm._s(props.item.estado))
                ]),
                _c(
                  "td",
                  { staticClass: "text-xs-center" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { color: "blue darken-2" },
                        on: {
                          click: function($event) {
                            return _vm.showDialog(props.item)
                          }
                        }
                      },
                      [_vm._v("\n          visibility\n        ")]
                    )
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "no-results",
            fn: function() {
              return [
                _c("v-alert", { attrs: { value: true, icon: "warning" } }, [
                  _vm._v(
                    '\n        Your search for "' +
                      _vm._s(_vm.search) +
                      '" found no results.\n      '
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "no-data",
            fn: function() {
              return [
                _c(
                  "v-alert",
                  {
                    staticClass: "alert",
                    staticStyle: { "text-align": "center" },
                    attrs: {
                      value: true,
                      icon: "warning",
                      color: "grey",
                      outline: ""
                    }
                  },
                  [
                    _vm._v(
                      "\n        Lo siento, no hay datos para mostrar :(\n      "
                    )
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm.dialogVisible
        ? _c("mis-solicitudes-dialog", {
            attrs: { dialog: _vm.dialogVisible, item: _vm.itemSelected },
            on: {
              close: function($event) {
                return _vm.closeDialog($event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }